import OwlCarouselSliderHomeFacility from "../../common/gallery/OwlCarouselSliderHomeFacility";
import DataSliderHomeFacility from "../../common/data/DataSliderHomeFacility";
const ServicesBlock = (props) => {
	return (		
	<div className="container-fluid">
		{/* <!-- TITLE START--> */}
		<div className="section-head text-center">
			<h1><span className="site-text-primary">Our </span> Facilities</h1>
			<div className="wt-separator-outer ">
				<div className="wt-separator style-icon">
					<i className="fa fa-leaf text-black"></i>
					<span className="separator-left site-bg-primary"></span>
					<span className="separator-right site-bg-primary"></span>
				</div>                            
			</div>
			<p>As the best sports school in Jaipur, {process.env.REACT_APP_SITE_TITLE}, {process.env.REACT_APP_SITE_ADDRESS} has a highly trained, successful and educated team of professional coaches to ensure the success of your child on the field. We provide opportunities to the students for physical activity, teamwork, leadership, and personal growth.</p>
		</div>
		{/* <!-- TITLE END--> */}
		<div className="section-content   our-services-index">
			<OwlCarouselSliderHomeFacility data={DataSliderHomeFacility}  />								
		</div>		
	</div>		 	
	);
};
ServicesBlock.defaultProps = {
    radius:"radius",
}
export default ServicesBlock;